import { useEffect, useRef, useState } from 'react';
import { Ic } from './Ic';
import { toast } from './Toast';

async function writeClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback for non-secure contexts, where navigator.clipboard is undefined.
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}

export function Copyable({
  text,
  label,
  className = 'btn ghost sm',
  iconOnly = false,
}: {
  text: string;
  label?: string;
  className?: string;
  iconOnly?: boolean;
}) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <button
      type="button"
      className={className}
      title={label ?? 'Copy'}
      aria-label={label ?? 'Copy'}
      onClick={async (e) => {
        e.stopPropagation();
        const ok = await writeClipboard(text);
        if (!ok) {
          toast('Could not copy to clipboard', 'error');
          return;
        }
        setCopied(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setCopied(false), 1400);
      }}
    >
      {/* Both icons stay mounted and crossfade (components.css .copy-ico). */}
      <span className="copy-ico" data-copied={copied} aria-hidden="true">
        <Ic.copy className="ico copy" />
        <Ic.check className="ico check" />
      </span>
      {!iconOnly && (label ?? 'Copy')}
    </button>
  );
}
